import React from 'react';

import useTranslate from '../../../common/hooks/useTranslate';

import Main from '../../layout/main/main';
import DocPinsSection from '../components/docPinSection/docPinSection';
import ActivityTable from '../components/activityFeed/activityTable/activityTable';
import DocuSign from '../../docuSign/components/docuSign/docuSign';
import WidgetPinSection from '../components/widgetPinSection/widgetPinSection';
import MediaSection from '../components/mediaSection/mediaSection';

const Home: React.FC = () => {
  const { t } = useTranslate();

  return (
    <Main title={t('HOME.PAGE_TITLE')}>
      <DocuSign />
      <MediaSection />
      <WidgetPinSection />
      <DocPinsSection />
      <ActivityTable />
    </Main>
  );
};

export default Home;
